import React, { useEffect, useState } from "react";
import Feed from "./Feed";
import Cure from "./Cure";
import Know from "./Know";
import Developer from "./Developer";
import flute from "../assets/flute.mp3";
import leaf from "../assets/leaf.png";
// about nidanam: what this page is about...
// the altruists
// cure
// dev
const tabs = [
    {
        label: "Nidānam",
        content: function ({ setActiveTab, hideFeedDot }) {
            return (
                <div
                    className="nidanam"
                    style={{
                        margin: "32px 0 0 0",
                        padding: "60px 60px",
                        minHeight: "fit-content",
                        background: "linear-gradient(-45deg, #f8fffc 0%, #e0f7fa 50%, #d0f8e8 100%)",
                        fontFamily: "Segoe UI, Roboto, Arial, sans-serif",
                        borderRadius: 22
                    }}
                >
                    <div
                        className="landing-box-content"
                        style={{
                            margin: "32px 0 0 0",
                            padding: "60px 100px 10px",
                            minHeight: "fit-content",
                            background: "#fff",
                            fontFamily: "Segoe UI, Roboto, Arial, sans-serif",
                            borderRadius: 22
                        }}
                    >
                        <h3 style={{ fontSize: 32 }}>
                            <img
                                style={{ marginRight: 15, filter: "hue-rotate(45deg)" }}
                                width={20}
                                src={leaf}
                                alt=""
                                srcset=""
                            />
                            About Nidānam
                        </h3>
                        <p style={{ marginTop: "60px" }}>
                            <p style={{ fontSize: 20, margin: "40px 0 10px", fontWeight: "bold" }}>
                                <span style={{ color: "" }}>
                                    सर्वेषामपि रोगाणां <span style={{ color: "#169503ff" }}> निदानं </span>कुपिता मलाः
                                    ||{" "}
                                </span>
                                <br />
                                Sarveṣāmapi rogāṇāṁ<span style={{ color: "#169503ff" }}> nidānaṁ </span> kupitā malāḥ ||
                                <br />
                                <br />
                                "The root cause of all diseases is the aggravation of the Malas (waste
                                products/Doshas)."
                            </p>
                            <br />
                            This is a collective platform where you can find information related to different diseases,
                            their cures, people who discovered those cures and different updates by health experts
                            related to health and wellness. The main aim of this platform is to help people recover and
                            spread awareness about different diseases and their cures using mostly natural remedies and
                            lifestyle changes.
                            <br />
                            <br />
                        </p>
                        <h3
                            style={{ cursor: "pointer", color: "#22643a" }}
                            onClick={() => {
                                setActiveTab(1);
                                if (hideFeedDot) hideFeedDot();
                            }}
                        >
                            Feed
                        </h3>
                        <p>
                            New posts, articles, videos, interviews and news related to health and wellness updated
                            regularly. If you want to contribute to the feed or wish to add something that might be
                            useful to people, please connect with me.
                        </p>
                        <h3 style={{ cursor: "pointer", color: "#22643a" }} onClick={() => setActiveTab(2)}>
                            Cure
                        </h3>
                        <p>
                            Find the different ways through which you can cure different diseases through various
                            methods. Find why it happens. Find ways to prevent it. Find and recognise early symptoms.
                            Connect with me if you know effective ways to treat a disease, natural remedies for cure or
                            lifestyle changes that can help people recover. We can add it here.
                        </p>
                        <h3 style={{ cursor: "pointer", color: "#22643a" }} onClick={() => setActiveTab(3)}>
                            Know
                        </h3>
                        <p>
                            Read about people who are behind the discovery and invention of important medicine and gain
                            knowledge about different ways of treatment. Gain inspiration from their stories and
                            journeys. Learn about their life and how they were inspired to help others.
                        </p>
                        <h3 style={{ cursor: "pointer", color: "#22643a" }} onClick={() => setActiveTab(4)}>
                            Developer
                        </h3>
                        <p>Find why this was started or contact me.</p>
                        <br />
                        <br />
                    </div>
                </div>
            );
        }
    },
    { label: "Feed", content: ({ turnOffAudio }) => <Feed turnOffAudio={turnOffAudio} /> },
    { label: "Cure", content: ({ turnOffAudio }) => <Cure turnOffAudio={turnOffAudio} /> },
    { label: "Know", content: ({ turnOffAudio }) => <Know turnOffAudio={turnOffAudio} /> },
    { label: "Developer", content: <Developer /> }
];

function Landing({ setAud }) {
    const [activeTab, setActiveTab] = useState(0);
    const [showFeedDot, setShowFeedDot] = useState(true);
    const turnOffAudio = () => {
        let audio = document.getElementById("audio");
        audio.pause();
        console.log("someshhh");
    };
    useEffect(() => {
        setAud(flute);
        let audio = document.getElementById("audio");
        setTimeout(() => {
            if (audio) {
                audio.play();
                audio.volume = 0.6;
                audio.currentTime = 0;
            }
        }, 200);
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [activeTab]);

    const [showAllTabs, setShowAllTabs] = useState(false);

    const hideFeedDot = () => setShowFeedDot(false);
    return (
        <div className="landing-page">
            <div className="tab-header">
                {window.innerWidth > 767 || showAllTabs ? (
                    <>
                        {window.innerWidth <= 767 ? (
                            <b style={{ marginBottom: -2, marginTop: 15 }}>Select from menu</b>
                        ) : null}
                        {tabs.map((tab, idx) => (
                            <button
                                key={tab.label}
                                className={`tab-btn${activeTab === idx ? " active" : ""}`}
                                onClick={() => {
                                    setActiveTab(idx);
                                    setShowAllTabs(false);
                                    if (tab.label === "Feed") hideFeedDot();
                                }}
                                style={{ position: "relative" }}
                            >
                                {tab.label === "Feed" && showFeedDot ? (
                                    <span
                                        className="red-dot"
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 2,
                                            width: 10,
                                            height: 10,
                                            background: "#e53935",
                                            borderRadius: "50%",
                                            border: "2px solid #fff",
                                            zIndex: 2,
                                            boxShadow: "0 0 3px #e53935",
                                            display: "inline-block"
                                        }}
                                    ></span>
                                ) : null}
                                {tab.label}
                            </button>
                        ))}
                    </>
                ) : (
                    <>
                        <button
                            onClick={() => setShowAllTabs(true)}
                            style={{ marginBottom: -2, marginTop: 15, fontSize: 18, color: "black" }}
                        >
                            Menu
                        </button>
                        <button key={activeTab.label} className="tab-btn active">
                            {tabs[activeTab].label}
                        </button>
                    </>
                )}
            </div>
            <div className="tab-content">
                {typeof tabs[activeTab].content === "function"
                    ? tabs[activeTab].content({ setActiveTab, turnOffAudio, hideFeedDot })
                    : tabs[activeTab].content}
            </div>
            <p
                className="me"
                style={{ position: "relative", bottom: -30, zIndex: 99, fontSize: 10, fontStyle: "italic" }}
            >
                Nidānam by Somesh Raichandani © 2025
            </p>
        </div>
    );
}

export default Landing;
